<template>
    <div v-loading="loaderProcessComplete" class="container-large hp-10">
        <step-finalize v-if="!isContextNew" v-show="processComplete" class="wp-6 m-auto">
            <h1>{{ $l10n.__('Merci de votre confiance et bonne journée sur Sellsy !') }}</h1>
            <CompassButton :label="$t.__('common.actions.go_sellsy')" @click="homeUrl" />
        </step-finalize>
        <step-finalize v-if="!isContextNew" v-show="processComplete" class="wp-6 m-auto">
            <h1 v-if="!isContextRenew" class="mb-2">
                {{ $l10n.__('Votre évolution a bien été prise en compte.') }}
            </h1>
            <h1 v-if="isContextRenew" class="mb-2">
                {{ $l10n.__('Votre renouvellement a bien été pris en compte.') }}
            </h1>
            <h1>{{ $l10n.__('Merci de votre confiance et bonne journée sur Sellsy !') }}</h1>
            <CompassButton
                :label="$t.__('sellsyaccountmanager.SubscriptionCheckout.continue_to_sellsy')"
                @click="homeUrl"
            />
        </step-finalize>
        <div v-show="!processComplete">
            <loader-full-page :display="loading" />
            <el-row v-show="!loading">
                <el-col :span="15" class="p-5">
                    <div class="grid-content">
                        <div class="flex-level flex-bottom">
                            <div class="round-64 relative dinlineb valign-middle primary-50-bkg">
                                <i
                                    class="fab fa-sellsy absolute-center white"
                                    style="font-size: 26px"
                                ></i>
                            </div>
                            <h2 class="ml-3 mt-0">
                                {{ $l10n.__('Abonnement Sellsy') }}
                            </h2>
                        </div>
                        <div class="m-auto left-block">
                            <h3 class="">
                                {{
                                    $filters.capitalize(
                                        $l10n.__('pour %(company)s', {
                                            company: customerProp.name,
                                        }),
                                    )
                                }}
                            </h3>
                            <div v-loading="loaderContact" class="well p-5 shadow mt-3">
                                <div class="flex-level">
                                    <h3 class="mt-0 mb-0">
                                        {{
                                            $filters.capitalize($l10n.__('informations de contact'))
                                        }}
                                    </h3>
                                    <div v-if="!editModeContact && userIsLogged" class="flex-right">
                                        <CompassButton
                                            :label="$t.__('common.actions.edit')"
                                            type="tertiary"
                                            @click="toggleContactEditMode()"
                                        />
                                    </div>
                                </div>
                                <el-form
                                    v-if="editModeContact"
                                    ref="billingContactForm"
                                    :model="billingContactTmp"
                                    label-position="top"
                                    class="mt-4"
                                    :rules="samBillingContactRules"
                                >
                                    <div class="flex-level">
                                        <div class="flex pr-2">
                                            <el-form-item
                                                :label="$t.__('common.labels.name')"
                                                prop="contactName"
                                                :error="errors.get('contactName')"
                                            >
                                                <text-input
                                                    v-model="billingContactTmp.contactName"
                                                    :mode="mode"
                                                />
                                            </el-form-item>
                                        </div>
                                        <div class="flex pl-2">
                                            <el-form-item
                                                :label="$t.__('common.labels.first_name')"
                                                prop="contactFirstName"
                                                :error="errors.get('contactFirstName')"
                                            >
                                                <text-input
                                                    v-model="billingContactTmp.contactFirstName"
                                                    :mode="mode"
                                                />
                                            </el-form-item>
                                        </div>
                                    </div>

                                    <el-form-item
                                        :label="$t.__('common.labels.email_address')"
                                        prop="contactEmail"
                                        :error="errors.get('contactEmail')"
                                    >
                                        <text-input
                                            v-model="billingContactTmp.contactEmail"
                                            type="email"
                                            :mode="mode"
                                        />
                                    </el-form-item>

                                    <el-form-item
                                        :label="$t.__('common.labels.phone')"
                                        prop="contactPhone"
                                        :error="errors.get('contactPhone')"
                                    >
                                        <tel-input
                                            v-model="billingContactPhoneTmp"
                                            :mode="mode"
                                            @change="updateBilligContactPhoneTmp"
                                        />
                                    </el-form-item>

                                    <el-form-item
                                        :label="$t.__('common.labels.invoicing_language')"
                                        prop="locale"
                                        :error="errors.get('locale')"
                                    >
                                        <select-input
                                            v-model="billingContactTmp.locale"
                                            :mode="mode"
                                            :options="billingLocales"
                                            label-column="name"
                                            id-column="code"
                                            :filterable="true"
                                            class="m-0"
                                        />
                                    </el-form-item>
                                    <p class="aright mt-6 mb-0">
                                        <CompassButton
                                            :label="$t.__('common.actions.cancel')"
                                            type="secondary"
                                            @click="toggleContactEditMode()"
                                        />
                                        <CompassButton
                                            :label="$t.__('common.actions.save')"
                                            class="ml-3"
                                            @click="
                                                submitForm(
                                                    'billingContactForm',
                                                    'saveBillingContact',
                                                )
                                            "
                                        />
                                    </p>
                                </el-form>
                                <div v-else class="fs-3 mt-3">
                                    <div v-if="isContactValid(billingContact)">
                                        <p class="m-0">
                                            {{ billingContact.contactName }}
                                            {{ billingContact.contactFirstName }}
                                        </p>
                                        <p class="m-0 mt-1">{{ billingContact.contactEmail }}</p>
                                        <p class="m-0 mt-1">{{ billingContact.contactPhone }}</p>
                                    </div>
                                    <p v-else class="italic red">
                                        {{ $l10n.__('Informations manquantes') }}
                                    </p>
                                </div>
                            </div>

                            <div v-loading="loaderAddress" class="well p-5 shadow mt-4">
                                <div class="flex-level">
                                    <h3 class="mt-0 mb-0">
                                        {{
                                            $filters.capitalize(
                                                $l10n.__('informations de facturation'),
                                            )
                                        }}
                                    </h3>
                                    <div v-if="!editModeAddress && userIsLogged" class="flex-right">
                                        <CompassButton
                                            :label="$t.__('common.actions.edit')"
                                            type="tertiary"
                                            @click="toggleAddressEditMode()"
                                        />
                                    </div>
                                </div>
                                <el-form
                                    v-if="editModeAddress"
                                    ref="billingAddressForm"
                                    :model="billingAddressTmp"
                                    label-position="top"
                                    class="mt-4"
                                    :rules="samBillingAddressAndIntraVatRules"
                                >
                                    <el-form-item
                                        :label="$t.__('common.labels.street_name')"
                                        prop="line1"
                                        :error="errors.get('line1')"
                                    >
                                        <algolia-places
                                            :default-value="billingAddressTmp.line1"
                                            :templates="{
                                                value: (suggestion) => {
                                                    return suggestion.name;
                                                },
                                            }"
                                            @bubble-address="captureAddress"
                                        ></algolia-places>
                                    </el-form-item>

                                    <el-form-item
                                        :label="$t.__('common.labels.more_address_informations')"
                                        prop="line2"
                                        :error="errors.get('line2')"
                                    >
                                        <text-input v-model="billingAddressTmp.line2" mode="edit" />
                                    </el-form-item>

                                    <div class="flex-level">
                                        <div class="flex pr-2">
                                            <el-form-item
                                                :label="$t.__('common.labels.postal_code')"
                                                prop="postalCode"
                                                :error="errors.get('postalCode')"
                                            >
                                                <text-input
                                                    v-model="billingAddressTmp.postalCode"
                                                    mode="edit"
                                                />
                                            </el-form-item>
                                        </div>
                                        <div class="flex-3 pl-2">
                                            <el-form-item
                                                :label="$t.__('common.labels.city')"
                                                prop="city"
                                                :error="errors.get('city')"
                                            >
                                                <text-input
                                                    v-model="billingAddressTmp.city"
                                                    mode="edit"
                                                />
                                            </el-form-item>
                                        </div>
                                    </div>

                                    <div class="flex-level">
                                        <div class="flex pr-2">
                                            <el-form-item
                                                :label="$t.__('common.labels.state')"
                                                prop="state"
                                                :error="errors.get('state')"
                                            >
                                                <text-input
                                                    v-model="billingAddressTmp.state"
                                                    mode="edit"
                                                    class="m-0"
                                                />
                                            </el-form-item>
                                        </div>
                                        <div class="flex pl-2">
                                            <el-form-item
                                                :label="$t.__('common.labels.country')"
                                                prop="country"
                                                :error="errors.get('country')"
                                            >
                                                <select-input
                                                    v-model="billingAddressTmp.country"
                                                    mode="edit"
                                                    :options="countries"
                                                    label-column="name"
                                                    id-column="code"
                                                    :filterable="true"
                                                    class="m-0"
                                                />
                                            </el-form-item>
                                        </div>
                                    </div>

                                    <div
                                        v-if="hasCountryIntraVat(billingAddressTmp.country)"
                                        class="mt-3"
                                    >
                                        <p>
                                            {{
                                                $l10n.__(
                                                    'Entrez un numéro de TVA intracommunautaire ci-dessous pour être facturé en franchise de TVA.',
                                                )
                                            }}
                                        </p>
                                        <el-form-item
                                            :label="
                                                $t.__(
                                                    'sellsyaccountmanager.SubscriptionCheckout.VAT_number',
                                                )
                                            "
                                            prop="vatIdentificationNumber"
                                            :error="errors.get('vatIdentificationNumber')"
                                        >
                                            <text-input
                                                v-model="billingAddressTmp.vatIdentificationNumber"
                                                mode="edit"
                                            />
                                        </el-form-item>
                                    </div>
                                    <p class="aright mt-6 mb-0">
                                        <CompassButton
                                            :label="$t.__('common.actions.cancel')"
                                            type="secondary"
                                            @click="toggleAddressEditMode()"
                                        />
                                        <CompassButton
                                            :label="$t.__('common.actions.save')"
                                            class="ml-3"
                                            @click="
                                                submitForm(
                                                    'billingAddressForm',
                                                    'saveBillingAddressAndVatIdentificationNumber',
                                                )
                                            "
                                        />
                                    </p>
                                </el-form>
                                <div v-else class="fs-3 mt-3">
                                    <div v-if="isAddressValid(billingAddress)">
                                        <p class="m-0 mt-1">{{ billingAddress.line1 }}</p>
                                        <p class="m-0 mt-1">{{ billingAddress.line2 }}</p>
                                        <p class="m-0 mt-1">
                                            {{ billingAddress.postalCode }}
                                            {{ billingAddress.city }} - {{ billingAddress.country }}
                                        </p>
                                        <p
                                            v-if="hasCountryIntraVat(billingAddress.country)"
                                            class="m-0 mt-3"
                                        >
                                            {{ $l10n.__('N° de TVA') }}
                                            {{ billingSettings.vatIdentificationNumber }}
                                        </p>
                                    </div>
                                    <p class="italic red" v-else>
                                        {{ $l10n.__('Informations manquantes') }}
                                    </p>
                                </div>
                            </div>
                            <div class="well p-5 shadow mt-4">
                                <h3 class="mt-0">
                                    {{ $filters.capitalize($l10n.__('moyen de paiement')) }}
                                </h3>
                                <div>
                                    <payment-methods
                                        v-if="!hasManualPaymentMethod"
                                        :corporation="corporation"
                                    ></payment-methods>
                                    <p
                                        v-if="
                                            hasManualPaymentMethod &&
                                            (isCartContext('new') || isCartContext('legacy_renew'))
                                        "
                                        class="fs-3 gray-60"
                                    >
                                        {{
                                            $l10n.__(
                                                'Merci d’effectuer un virement du montant de votre abonnement vers le compte ci-dessous. A réception du virement nous procéderons à l’activation de votre compte.',
                                            )
                                        }}
                                    </p>
                                    <p
                                        v-if="hasManualPaymentMethod && isCartContext('renew')"
                                        class="fs-3 gray-60"
                                    >
                                        {{
                                            $l10n.__(
                                                'Merci d’effectuer un virement du montant de votre abonnement vers le compte ci-dessous.',
                                            )
                                        }}
                                    </p>
                                    <p
                                        v-if="hasManualPaymentMethod && isCartContext('upsale')"
                                        class="fs-3 gray-60"
                                    >
                                        {{
                                            $l10n.__(
                                                'Merci d’effectuer un virement du montant de la facture vers le compte ci-dessous.',
                                            )
                                        }}
                                    </p>
                                    <div v-if="hasManualPaymentMethod" class="mt-2">
                                        <p class="m-0 fs-3 gray-60">
                                            {{
                                                $filters.capitalize($l10n.__('Titulaire du compte'))
                                            }}
                                        </p>
                                        <p class="m-0 fs-3 semibold">
                                            {{
                                                $filters.capitalize(
                                                    $l10n.__(
                                                        'SAS SELLSY - AVENUE DU LAZARET 17000 LA ROCHELLE',
                                                    ),
                                                )
                                            }}
                                        </p>

                                        <line-2-slots class="fs-3 mt-2">
                                            <template #left>
                                                <p class="m-0 fs-3 gray-60">
                                                    {{
                                                        $filters.capitalize(
                                                            $l10n.__(
                                                                'IBAN (International Bank Account Number)',
                                                            ),
                                                        )
                                                    }}
                                                </p>
                                                <p class="m-0 fs-3 semibold">
                                                    {{
                                                        $filters.capitalize(
                                                            $l10n.__(
                                                                'FR76 1090 7008 6103 0211 3904 631',
                                                            ),
                                                        )
                                                    }}
                                                </p>
                                            </template>
                                            <template #right>
                                                <p class="m-0 fs-3 gray-60">
                                                    {{
                                                        $filters.capitalize(
                                                            $l10n.__('BIC (International Code)'),
                                                        )
                                                    }}
                                                </p>
                                                <p class="m-0 fs-3 semibold" align="right">
                                                    {{
                                                        $filters.capitalize($l10n.__('CCBPFRPPBDX'))
                                                    }}
                                                </p>
                                            </template>
                                        </line-2-slots>
                                    </div>
                                </div>
                                <span v-if="errors.get('card')" class="red error semibold"
                                    >{{ errors.get('card') }}<br
                                /></span>
                            </div>
                        </div>
                    </div>
                </el-col>
                <el-col :span="9">
                    <div
                        class="grid-content well p-8 b-0 fixed top-0 hp-10 wp-4 ovy-scroll right-0"
                    >
                        <div v-if="!loading" class="subscription-preview-container m-auto">
                            <subscription-preview
                                :is-monthly="cartProp.pricingPlanId === 'MONTHLY'"
                                :cart="cartProp"
                                :country-code="billingAddress.country"
                                :click-enabled="readyToPay"
                                :has-manual-payment-method="hasManualPaymentMethod"
                                @clicked="save"
                            />
                        </div>
                    </div>
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
import { goToUrl } from 'vueDir/helpers.js';
import WidgetStore from '../../mixins/sellsyaccountmanager/store/widgetStoreMixins';
import WidgetMixins from '../../mixins/sellsyaccountmanager/widgetMixins';

import FormMixins from '../../mixins/FormMixins';
import SamMixins from '../../mixins/subscription/SAMMixins';
import StripeMixins from '../../mixins/StripeMixins';
import TelInput from '../inputs/TelInput.vue';
import AlgoliaInput from '../inputs/AlgoliaInput.vue';
import SubscriptionPreview from './SubscriptionPreview.vue';
import StepFinalize from './subscriptionform/StepFinalize.vue';
import Line2Slots from '../utilities/Line2slots.vue';
import SelectInput from 'vcomponents/inputs/SelectInput.vue';
import TextInput from 'vcomponents/inputs/TextInput.vue';
import LoaderFullPage from 'vcomponents/utilities/LoaderFullPage.vue';
import PaymentMethods from './subscriptioncheckout/PaymentMethods.vue';
import CustomerMixins from '../../mixins/sellsyaccountmanager/customerMixins';
import Env from 'Services/Env';

export default {
    components: {
        PaymentMethods,
        'select-input': SelectInput,
        'text-input': TextInput,
        LoaderFullPage,
        Line2Slots,
        TelInput,
        'algolia-places': AlgoliaInput,
        SubscriptionPreview,
        StepFinalize,
    },
    mixins: [SamMixins, FormMixins, StripeMixins, WidgetStore, WidgetMixins, CustomerMixins],
    props: {
        customerProp: { type: Object, required: true },
        billingSettingsProp: { type: Object, required: true },
        billingAddressProp: { type: Object, required: true },
        cartProp: { type: Object, required: true },
        productsProp: { type: Array, required: true },
        plansProp: { type: Array, required: true },
        subscribedProductsProp: { type: Array, required: true },
    },
    data() {
        return {
            mode: 'edit',
            subscription: {},
            editModeContact: false,
            editModeAddress: false,
            stripeForm: {},
            loadedInMixin: false,
            loading: true,
            loaderContact: false,
            loaderAddress: false,
            processComplete: false,
            loaderProcessComplete: false,
            publishableKey: Env.get('stripe').publishableKey,
        };
    },
    computed: {
        readyToPay() {
            return (
                this.isAddressValid(this.billingAddress) &&
                this.isContactValid(this.billingContact) &&
                this.paymentMethodIsValid &&
                !this.editModeContact &&
                !this.editModeAddress
            );
        },
        corporation() {
            return this.customerProp.saasCorpId;
        },
        billingContact() {
            let contactProperties = [
                'contactEmail',
                'contactFirstName',
                'contactName',
                'contactPhone',
                'locale',
            ];
            return _.pick(this.billingSettings, ...contactProperties);
        },
        hasManualPaymentMethod() {
            return this.cartProp.paymentMethod == 'manual';
        },
        isContextNew() {
            return this.cartProp.context == 'new';
        },
        isContextRenew() {
            return this.cartProp.context == 'renew' || this.cartProp.context == 'legacy_renew';
        },
        paymentMethodIsValid() {
            return (
                !this.hasManualPaymentMethod &&
                (this.stripeElement._complete ||
                    (this.stripeElement._empty &&
                        !!this.customerCreditCard &&
                        !this.customerCreditCard.isExpired))
            );
        },
    },
    created() {
        this.getCountries().then((countries) => this.setCountries(countries));
        this.getBillingLocales().then((billingLocales) => this.setBillingLocales(billingLocales));

        Promise.all([
            !this.hasManualPaymentMethod ? this.createPaymentIntentForCart(this.cartProp.id) : null,
            this.setCustomerCorporation(this.corporation),
            this.setBillingSettings(this.billingSettingsProp),
            this.setBillingAddress(this.billingAddressProp),
            this.setCartPaymentFacility(this.cartProp.paymentFacility),
            this.setPricingPlans(this.plansProp),
            this.setPricingProducts(this.productsProp),
            this.setCustomerSubscribedProducts(this.subscribedProductsProp),
        ])
            .then(() => this.feedFormFromCart(this.cartProp))
            .finally(() => (this.loading = false));
    },
    methods: {
        saveCardOrPay() {
            /* Renew and Upsale can allow a registered credit card */
            if (['renew', 'upsale'].includes(this.cartProp.context)) {
                if (!this.stripeElement._complete && !!this.customerCreditCard) {
                    return this.checkPaymentForCart(this.cartProp.id);
                } else if (this.stripeElement._complete) {
                    return this.stripeCreateCardToken()
                        .then((token) => this.recordStripeToken(this.corporation, token.id))
                        .then(() => this.checkPaymentForCart(this.cartProp.id));
                }
            }

            if (this.cartPaymentIntent.clientSecret && this.cartPaymentIntent.amount > 0) {
                return this.stripeConfirmPaymentIntent(this.cartPaymentIntent.clientSecret, true);
            }

            return this.stripeCreateCardToken()
                .then((token) => this.recordStripeToken(this.corporation, token.id))
                .then((token) => this.checkPaymentForCart(this.cartProp.id));
        },
        save() {
            this.loaderProcessComplete = true;
            return this.saveCardOrPay()
                .then((token) => {
                    // finalize
                    this.processComplete = true;
                })
                .catch((error) => {
                    if (error.message == 'payment_intent_unexpected_state_succeeded')
                        return (this.processComplete = true);
                    this.errors.setOneError('card', this.errorLabel(error.message));
                    Push.error(this.$l10n.__('Vos informations de facturation sont invalides'));
                })
                .finally(() => (this.loaderProcessComplete = false));
        },
        stripeInitElements() {
            if (this.hasManualPaymentMethod) return;
            let locale = window.App.lang && window.App.lang != '' ? window.App.lang : 'auto';
            this.stripeElement = this.stripeResources.lib
                .elements({ locale: locale })
                .create('card', { hidePostalCode: true });
            this.stripeElement.mount('#creditcard');
        },
        saveBillingContact() {
            this.loaderContact = true;

            if (!this.isContactValid(this.billingContactTmp, this.billingContactPhoneTmp)) {
                Push.error(
                    this.$l10n.__(
                        'Les informations de votre contact de facturation sont nécessaires pour la construction de votre abonnement',
                    ),
                    this.$l10n.__('Contact de facturation'),
                );
                this.loaderContact = false;
                return;
            }

            return Promise.all([
                this.billingContactHasChanged
                    ? this.updateBillingContact(this.billingContactTmp, this.billingContactPhoneTmp)
                    : null,
            ]).finally(() => {
                this.editModeContact = false;
                this.loaderContact = false;
            });
        },
        saveBillingAddressAndVatIdentificationNumber() {
            this.loaderAddress = true;
            if (!this.isAddressValid(this.billingAddressTmp)) {
                Push.error(
                    this.$l10n.__(
                        'Les informations de votre adresse de facturation sont insuffisantes',
                    ),
                    this.$l10n.__('Adresse de facturation'),
                );
                this.loaderAddress = false;
                return;
            }

            let countryHasChanged = this.billingAddress.country != this.billingAddressTmp.country;
            let vatIdentifierHasChanged =
                this.billingSettings.vatIdentificationNumber !=
                this.billingAddressTmp.vatIdentificationNumber;
            let vatIdentifierHasBeenToggled =
                !!this.billingSettings.vatIdentificationNumber !=
                !!this.billingAddressTmp.vatIdentificationNumber;

            return Promise.all([
                this.billingAddressHasChanged
                    ? this.updateBillingAddress(this.billingAddressTmp)
                    : null,
                vatIdentifierHasChanged
                    ? this.updateBillingSettings(
                          _.merge(this.billingSettings, {
                              vatIdentificationNumber:
                                  this.billingAddressTmp.vatIdentificationNumber,
                          }),
                      )
                    : null,
            ])
                .then(() => {
                    if (
                        this.hasManualPaymentMethod ||
                        (!countryHasChanged && !vatIdentifierHasBeenToggled)
                    )
                        return;
                    // if country has changed, create a new payment intent with the right tax rate
                    this.createPaymentIntentForCart(this.cartProp.id);
                })
                .then(() => {
                    this.editModeAddress = false;
                    this.loaderAddress = false;
                });
        },
        toggleContactEditMode() {
            this.initBillingContactTmp();
            this.editModeContact = !this.editModeContact;
        },
        toggleAddressEditMode() {
            this.initBillingAddressTmp();
            this.editModeAddress = !this.editModeAddress;
        },
        updateBillingAddress(billingAddress) {
            return this.recordBillingAddress(this.corporation, billingAddress).then((address) =>
                this.setBillingAddress(address),
            );
        },
        updateBillingSettings(billingSettings) {
            return this.recordBillingSettings(this.corporation, billingSettings).then((settings) =>
                this.setBillingSettings(settings),
            );
        },
        updateBillingContact(billingContact, billingContactPhone) {
            return this.recordBillingContact(
                this.corporation,
                billingContact,
                billingContactPhone,
            ).then((settings) => this.setBillingSettings(settings));
        },
        homeUrl() {
            return goToUrl('/home');
        },
    },
};
</script>

<style scoped lang="scss">
.subscription-preview-container {
    width: 416px;
}

.left-block {
    width: 640px;
}
</style>

<style lang="scss">
.page-sam-selfservice-cart-checkout {
    .el-input {
        input {
            height: 32px;
        }
    }
}
</style>
